const getStripeKey = () => {
  const hostname = window.location.hostname;

  if (hostname === 'app.superagi.com' || hostname === 'www.superagi.com' || hostname === 'billing.superagi.com') {
    return 'pk_live_51Q2wruLI2fesze2G0irdy60MHxMukUgZ7pGm0HIymX5jvogLBdpCknhXW8miPEnJ1jpItyhAKSg6TMkwOxurfdIS00Ypo4yfpt';
  }

  if (hostname === 'staging.superagi.com' || hostname.includes('staging')) {
    return 'pk_test_51Q1dKR2Lah9n4H6WaRgztmhhDT7inpwFvOWnRRL8JM1D83qEqbJf8mxstfPog5AkQJTPjAFMAzimJFTN1iIcgyVR0015T9B2Kq';
  }

  return 'pk_test_51Q2wruLI2fesze2GVfzcbfsPj3xHGUCQSLXQ3bCJhJv7mTeuj0npfdsDL1ngJKNlqvNA4TMNzP05gouIhoy1nNWd00nLJ6LhE6';
};

export const STRIPE_PUBLISHABLE_KEY = getStripeKey();

export const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname === 'app.superagi.com' || hostname === 'www.superagi.com' || hostname === 'billing.superagi.com') {
    return 'production';
  }

  if (hostname === 'staging.superagi.com' || hostname.includes('staging')) {
    return 'staging';
  }

  return 'local';
};

export const ENVIRONMENT = getEnvironment();
